import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {I18NextPipe} from "@kokos-i18next";
import {HistorienElement} from "../../../core/model/historien-element";
import {getPostfachFormat} from "../../../shared/utils/date-time.helper";
import {NachrichtDetailComponent} from "../../../shared/components/nachricht-detail/nachricht-detail.component";
import {PersonDisplayService} from "../../../core/services/person-display.service";
import {
    I18nRerenderOnLanguageChangeDirective
} from "../../../shared/directives/i18n-rerender-on-language-change.directive";

@Component({
  selector: 'kokos-nachricht-verlauf',
    imports: [
        I18NextPipe,
        NachrichtDetailComponent,
        I18nRerenderOnLanguageChangeDirective
    ],
  templateUrl: './nachricht-verlauf.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NachrichtVerlaufComponent {

  @Input() nachrichtHistorie: HistorienElement[] = [];

  protected readonly personDisplayService = inject(PersonDisplayService);

  protected readonly getPostfachFormat = getPostfachFormat;
  isCollapsed = true;

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }

}
